import { render, staticRenderFns } from "./DevAreaLocationList.vue?vue&type=template&id=b3ccc5a4&scoped=true&"
import script from "./DevAreaLocationList.vue?vue&type=script&lang=js&"
export * from "./DevAreaLocationList.vue?vue&type=script&lang=js&"
import style0 from "./DevAreaLocationList.vue?vue&type=style&index=0&id=b3ccc5a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ccc5a4",
  null
  
)

export default component.exports